import { observable } from 'mobx';
import { getFormattedText } from '../../utils/StringUtils';
import { DEFAULT_DATE_FORMAT } from '../../utils/Constants';
import { formatDate } from '../../utils/DateUtils';
import { IOrderTrackingConfig } from './Config';

export class ShippingInfo {
    @observable public carrierCode: string;
    @observable public shippedDate: string;
    @observable public trackingNumber: string;

    @observable public trackingUrl: string;
    @observable public cutOffTime: string;
    @observable public carrierName: string;
    @observable public shippedDateFormattedString: string;

    constructor(
        data: {
            carrier: string;
            order_date: string;
            service: string;
            ship_date: string;
            tracking_number: string;
            trans_id: number;
            trans_order_id: number;
        },
        {
            dateFormatPattern = DEFAULT_DATE_FORMAT,
            carrierCodes
        }: Pick<IOrderTrackingConfig, 'dateFormatPattern' | 'carrierCodes'>,
        defaultCarrierCode?: string,
        is_return?: boolean,
        return_tracking_url?: string
    ) {
        this.trackingNumber = data.tracking_number;
        const carrierCode = data.carrier || defaultCarrierCode || '';
        this.carrierCode = carrierCode;
        if (carrierCode && carrierCodes) {
            const carrierInfo = carrierCodes.find(
                (item) => item.carrierCode.toLowerCase() === carrierCode.toLowerCase()
            );
            if (carrierInfo) {
                const { carrierName, cutOffTime = '', carrierTrackingUrl } = carrierInfo;
                this.carrierName = carrierName;
                this.cutOffTime = cutOffTime;
                this.trackingUrl = is_return
                    ? return_tracking_url || ''
                    : getFormattedText(carrierTrackingUrl || '', data);
            }
        }
        this.shippedDate = data.ship_date;
        this.shippedDateFormattedString = formatDate(this.shippedDate, dateFormatPattern);
    }
}
